import {Box, Flex, Tag} from 'exsportia-components'
import React, {FC} from 'react'

import {useSubscription} from '../../api/subscriptions/hooks'
import {useVenue} from '../../api/venue/hooks'
import {PreviewCard} from '../../ui/components/preview-card/preview-card'

export type SubscriptionPreviewCardProps = {
  id?: string
  chips?: {
    text: string
    color: string
    textColor: string
  }[]
}

export const SubscriptionPreviewCard: FC<SubscriptionPreviewCardProps> = ({
  id,
  chips = [],
}) => {
  const {data: venue} = useVenue()
  const {data: subscription} = useSubscription(id)
  return (
    <Box width={'100%'}>
      <Flex
        height='0'
        overflow='visible'
        position={'relative'}
        zIndex={1}
        flexWrap='wrap'
        gap='8px'
        top='12px'
        left='12px'
      >
        {chips.map(({text, color, textColor}, i) => (
          <Tag
            key={`${text}-${i}`}
            text={text}
            settings={{bg: color, iconWithText: {text: {color: textColor}}}}
          />
        ))}
      </Flex>
      <PreviewCard
        title={subscription?.name}
        image={subscription?.logo.secure_url}
        subtitle={venue?.name}
      />
    </Box>
  )
}
